import Api from './Api';

export default {
    login: function (credentials) {
        var url = '/user/login';
        url += '?kta_id=' + credentials.kta_id;

        var form = new FormData();
        form.append('email', credentials.email);
        form.append('password', credentials.password);

        return Api().post(url, form);
    },

    logout: function (credentials) {
        var url = '/user/logout';

        var form = new FormData();
        form.append('api_token', credentials.api_token);

        return Api().post(url, form);
    },

    signup: function (credentials) {
        var url = '//pourlo.catalogue-interactif.com/app/api/user/register';
        url += '?kta_id=' + credentials.kta_id;

        var form = new FormData();


        form.append('gender', credentials.gender); //

        form.append('profession', credentials.profession);

        form.append('last_name', credentials.last_name);
        form.append('first_name', credentials.first_name);
        form.append('name', credentials.first_name + ' ' + credentials.last_name); //

        form.append('company', credentials.company);
        form.append('tva', credentials.tva);

        form.append('sector', credentials.sector);
        form.append('site', credentials.site);

        form.append('phone', credentials.phone);
        form.append('cellphone', credentials.cellphone);

        form.append('address', credentials.address);

        form.append('postal_code', credentials.postal_code);
        form.append('city', credentials.city);
        form.append('postal_code_and_city', credentials.postal_code + ' - ' + credentials.city);
        
        form.append('country', credentials.country);

        form.append('email', credentials.email);
        form.append('email_confirmation', credentials.confirm_email);

        form.append('password', credentials.password);
        form.append('password_confirmation', credentials.confirm_password);

        form.append('terms_accepted', credentials.terms_accepted);

        form.append('version', 2); //

        return Api().post(url, form);
    },

    reset_password: function (credentials) {
        var url = '/user/send-reset-token';
        url += '?kta_id=' + credentials.kta_id;

        var form = new FormData();
        form.append('email', credentials.email);
        form.append('version', 2); //

        return Api().post(url, form);
    },

    confirm_password: function (credentials) {
        var url = '/user/reset-password';
        url += '?kta_id=' + credentials.kta_id;

        var form = new FormData();
        // form.append('token', credentials.token);
        // form.append('password', credentials.password);
        // form.append('password_confirmation', credentials.password_confirmation);
        // form.append('email', credentials.email);

        form.append('token', credentials.token);
        form.append('email', credentials.email);
        form.append('password', credentials.password);
        form.append('password_confirmation', credentials.confirm_password);

        return Api().post(url, form);
    }
};
